import { WIRTransverseRoles } from 'types/wellGuardian';

export const getRoleName = (role: string) => {
  switch (role) {
    case WIRTransverseRoles.READ_ONLY_WIR_USER:
      return 'Read Only User';
    case WIRTransverseRoles.WIR_USER:
      return 'WIR User';
    case WIRTransverseRoles.WIR_SUPER_USER:
      return 'WIR Super User';
    case WIRTransverseRoles.INTERVENTION_SUPERINTENDANT:
      return 'Intervention Superintendant';
    case WIRTransverseRoles.INTERVENTION_LEAD_ENGINEER:
      return 'Intervention Lead Engineer';
    case WIRTransverseRoles.INTERVENTION_ENGINEER:
      return 'Intervention Engineer';
    case WIRTransverseRoles.WS_TECHNICAL_ASSISTANT:
      return 'WS Technical Assistant';
    case WIRTransverseRoles.ASSET_FOCAL_POINT:
      return 'Asset Focal Point';
    case WIRTransverseRoles.ASSET_MANAGER:
      return 'Asset Manager';
    case WIRTransverseRoles.ASSET_BUDGET_HOLDER:
      return 'Asset Budget Holder';
    case WIRTransverseRoles.GSR_MANAGER:
      return 'GSR Manager';
    case WIRTransverseRoles.GSR_FIELD_LEADER:
      return 'GSR Field Lead';
    case WIRTransverseRoles.HEAD_OF_RESERVOIR:
      return 'Head of Reservoir';
    case WIRTransverseRoles.COMPLETIONS_LEAD:
      return 'Completions Lead';
    case WIRTransverseRoles.WSC_LEADER:
      return 'Well Integrity Focal Point';
    case WIRTransverseRoles.DW_LEAD:
      return 'DW Leader';
    case WIRTransverseRoles.PERFORMANCE_LEAD:
      return 'Performance Lead';
    case WIRTransverseRoles.DW_MANAGER:
      return 'DW Manager';
    case WIRTransverseRoles.OFFSHORE_INTERVENTION_SUPERVISOR:
      return 'Offshore Intervention Supervisor';
    case WIRTransverseRoles.SMART_ROOM_FOCAL_POINT:
      return 'Smart Room Focal Point';
    case WIRTransverseRoles.COST_ADMIN:
      return 'Cost Admin';
    case WIRTransverseRoles.CHEMIST:
      return 'Chemist';
    case WIRTransverseRoles.PLANNER:
      return 'Planner';
    case WIRTransverseRoles.JV_REP:
      return 'JV Rep';
    case WIRTransverseRoles.WELL_EXAMINER:
      return 'Well Examiner';
    case WIRTransverseRoles.WELL_REVIEW_USER:
      return 'Well Review User';
    default:
      return role;
  }
};
